/**
 * Runtime configuration, written to S3 by Terraform. Fetching it at startup keeps
 * environment values out of the bundle, so the same build can be promoted between
 * environments without rebuilding.
 */
export interface PortalConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  hostedUiDomain: string;
  redirectUri: string;
  apiBaseUrl: string;
  environment: string;
  /** SAML provider to go straight to, skipping the hosted UI's provider list. */
  identityProvider?: string;
}

let cached: PortalConfig | undefined;

export async function loadConfig(): Promise<PortalConfig> {
  if (cached) return cached;

  const response = await fetch('/config.json', { cache: 'no-store' });

  if (!response.ok) {
    throw new Error(`Could not load portal configuration (HTTP ${response.status}).`);
  }

  cached = (await response.json()) as PortalConfig;
  return cached;
}
